import styled from "styled-components"
import { media } from "utils/utils"

export const Body = styled.div`
  padding-top: ${props => (props.hasMessage ? "120px" : "90px")};
  position: relative;
  ${media.md`
     padding-top: ${props => (props.hasMessage ? "110px" : "80px")};
  `};
  background-color: #ffffff;
  padding-bottom: 50px;
`

export const LogoContainerMobile = styled.div`
  display: none;
  width: 30%;
  margin: ${props => (props.showLocationFilter ? "0 0 0 25px" : "0 auto")};

  @media (max-width: 800px) {
    display: block;
    width: 33%;
    margin: ${props => (props.showLocationFilter ? "0 0 0 15px" : "0 auto")};
  }
`

export const SideContainer = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  margin: 0 20px;
`

export const SideContainerCountrySelectField = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  margin: 0 20px;

  @media (max-width: 800px) {
    margin: 0;
    width: 33%;
  }
`

export const SideContainerGlobal = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  margin: 0 20px;

  @media (max-width: 800px) {
    display: none;
  }
`

export const LogoContainerDesktop = styled.div`
  display: none;
  width: 30%;
  height: 140px;
  max-width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;

  @media (min-width: 800px) {
    display: flex;
  }
`
export const ILogo = styled.img`
  height: auto;
  max-height: 75px;
  max-width: ${props => props.logoWidth};
  margin: 0 auto 0 auto;
  display: block;
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.headerBGcolour};
  height: 140px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;

  @media (max-width: 800px) {
    height: 60px;
    justify-content: ${props =>
      props.showLocationFilter ? "space-between" : "flex-start"};
  }
`

export const Footer = styled.footer``
